import { useMemo } from "react";
import { useAppSelector } from "../../framework/customStore";
import { makeSelectPublishedWorkShiftsByDate, makeSelectPublishedWorkShiftsDurationByDate } from "../../store/workShiftPublishedSlice";

export const useSelectPublishedWorkShiftsByDate = (
    rangeStart: string,
    rangeEnd: string,
    employeeId: string
) => {
    const state = useAppSelector((state) => state.workShiftPublished);

    const selectWorkShiftsByDate = useMemo(
        makeSelectPublishedWorkShiftsByDate,
        []
    );
    return selectWorkShiftsByDate(state, rangeStart, rangeEnd, employeeId);
};

export const useSelectPublishedWorkShiftsDurationByDate = (
    rangeStart: string,
    rangeEnd: string,
    employeeId: string
) => {
    const state = useAppSelector((state) => state.workShiftPublished);

    const selectWorkShiftsDurationByDate = useMemo(
        makeSelectPublishedWorkShiftsDurationByDate,
        []
    );
    return selectWorkShiftsDurationByDate(state, rangeStart, rangeEnd, employeeId);
};
